var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10369_17281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.947266 0.946615H17.6139V17.6133H0.947266V0.946615Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10369_17281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9617 2.14629C14.9617 1.66071 14.5681 1.26712 14.0825 1.26712H2.29326C1.80771 1.26712 1.41406 1.66071 1.41406 2.14629V3.53125H14.9617V2.14629Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86908 14.0586H13.3574L13.0838 11.8258C13.0731 11.7399 13.1658 11.6789 13.2407 11.7227L14.9616 12.7308V3.53122H1.41406V13.1795C1.41406 13.6651 1.80758 14.0586 2.2932 14.0586H7.01738",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0858 11.8284L13.5895 15.9378C13.6008 16.0298 13.7173 16.0629 13.7752 15.9905L14.3552 15.2664C14.3997 15.2108 14.4854 15.2148 14.5245 15.2743L15.815 17.2379C15.8468 17.2863 15.9117 17.2997 15.9601 17.2679L16.5279 16.8948L17.0957 16.5216C17.144 16.4898 17.1574 16.4249 17.1257 16.3765L15.8351 14.4129C15.7961 14.3535 15.8264 14.2731 15.895 14.2543L16.7898 14.0093C16.8792 13.9848 16.8951 13.8647 16.8151 13.8178L13.2427 11.7253C13.1679 11.6814 13.0752 11.7423 13.0858 11.8284Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14238 7.71094H3.95801V5.53509H6.14238V7.71094Z",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16211 5.53516H12.4242",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16211 7.58984H12.4242",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95801 9.64844H12.4253",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95801 11.7031H10.9914",
    stroke: "white",
    strokeWidth: 0.78125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPage);
export default __webpack_public_path__ + "static/media/landing-page.f0cfb4b450c4ca0e59a5f8620f8f4de6.svg";
export { ForwardRef as ReactComponent };